<template>
    <v-dialog persistent  v-model="dialog" max-width="500">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>Cancelar Cita</v-toolbar-title>
                <v-spacer></v-spacer>
                    <v-btn icon dark @click="hide">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-layout wrap align-center justify-center>
                        <v-flex xs12  text-xs-center>
                            <v-select label="Seleccione el motivo" box v-model="reason" :items="baseReasons"></v-select>
                        </v-flex>
                        <v-slide-y-transition>
                            <v-flex v-show="reason === 'other'" xs12  text-xs-center>
                                <v-textarea label="Describa el motivo" box v-model="customReason" :rules="rules"/>
                            </v-flex>
                        </v-slide-y-transition>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" round :disabled="!valid" color="primary" depressed @click="cancelAppointment">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {getLabel} from '@/utils/Institution'

    import {mapState, mapMutations} from 'vuex'

    export default{
        props: [],
        data(){
            return {
                dialog: false,
                other: false,
                reason: '',
                customReason: '',
                appointmentId: null,
                loading: false,
                rules: [
                        v => !!v || 'Este campo es obligatorio',
                        v => v.length > 10 || 'Requiere al menos 10 caracteres',
                ]
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            getLabel,
            show(appointmentId){
                this.appointmentId = appointmentId
                this.dialog = true
            },
            hide(){
                this.dialog = false
            },
            async cancelAppointment(){
                var vm = this

                if(vm.loading) return

                vm.loading = true
                const reason = vm.reason !== 'other' ? vm.reason : vm.customReason
                const response = await ApiUtils.makePost(`appointments/${vm.appointmentId}/cancel`, {
                    reason: reason
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando cancelar la cita')
                    vm.$emit('error', json)
                    return
                }

                const json = await response.json()
                vm.showSnackBar('La cita ha sido cancelada')
                vm.$emit('success', json)
                vm.hide()

            }
        },
        computed: {
            valid(){
                var vm = this
                return ((vm.reason && vm.reason !== 'other') || (vm.customReason && vm.reason === 'other'))
            },
            baseReasons(){
                return [
                    {
                        text: `El ${getLabel('commons.client.singular').toLowerCase()} encontro hora en otro centro`,
                        value: 'another_institution'
                    },
                    {
                        text: `No se pudo contactar al ${getLabel('commons.client.singular').toLowerCase()}`,
                        value: 'cant_contact_client'
                    },
                    {
                        text: `Otro`,
                        value: 'other'
                    },
                ]
            }
        },
        watch:{
            reason(val){}
        }

    }
</script>